import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetUserRolesResponseDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type UseIssuePermissionsQueryResult = UseQueryResult<
  GetUserRolesResponseDto,
  ExtendedAxiosError
>;

export function useIssuePermissions(
  code: string | undefined,
): UseQueryResult<GetUserRolesResponseDto, ExtendedAxiosError> {
  const api = useApi();

  return useQuery<GetUserRolesResponseDto, ExtendedAxiosError>({
    queryKey: ['user-roles', code],
    // Because of the "enabled" option, code is always defined here
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => api.issuesApi.getUserRoles(code!).then((r) => r.data),
    enabled: !!code,
  });
}
